import { Link, LinkProps } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface BaseLinkProps extends LinkProps {
    route: string;
}

const BaseLink: React.FC<BaseLinkProps> = (props) => {
    const { route, title, children, ...linkProps } = props;
    return (
        <Link
            to={`${route}`}
            component={RouterLink}
            width={"auto"}
            {...linkProps}
        >
            {title && title}
        </Link>
    )
}

export default BaseLink;